import { commitmentsForGranularSelector } from "./source/commitmentsForGranularSelector";
import { RootState } from "../../../../store";
import { SavingsPlanData } from "../../../../../services/cloudchipr.api";

export const commitmentsDataForGranularSelector = (
  state: RootState,
): SavingsPlanData | undefined => {
  return commitmentsForGranularSelector(state)?.data;
};
